import { showConfirmDialog } from 'components/shared/dialog';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import {
    approveFund,
    createFund,
    deleteFund,
    deleteFundHistory,
    exportFund,
    updateFund
} from '../../actions/arr/fund';
import { globalFundTreeInvalidate } from '../../actions/arr/globalFundTree';
import {
    DEFAULT_FUND_LIST_MAX_SIZE,
    fundsExportResults,
    fundsFetchIfNeeded,
    fundsFilter,
    fundsFundDetailFetchIfNeeded,
    fundsSearch,
    fundsSelectFund,
    getFundDetail
} from '../../actions/fund/fund';
import { modalDialogShow } from '../../actions/global/modalDialog';
import { WebApi } from '../../actions/index';
import { refInstitutionsFetchIfNeeded } from '../../actions/refTables/institutions';
import { refRuleSetFetchIfNeeded } from '../../actions/refTables/ruleSet';
import { scopesDirty } from '../../actions/refTables/scopesData';
import { routerNavigate } from '../../actions/router';
import * as perms from '../../actions/user/Permission';
import { ExportForm, FundForm, Icon, ImportForm } from '../../components';
import IssueLists from '../../components/arr/IssueLists';
import SearchFundsForm from '../../components/arr/search-funds-form/SearchFundsForm';
import { FundListImportListener } from '../../components/arr/FundListImportListener';

import { AbstractReactComponent, ListBox } from '../../components/shared';
import { urlEntity, urlFund, urlFundOutputs, urlFundTree } from "../../constants";
import { globalMessages } from '../../components/shared/lang';
import { addToastrDanger, addToastrInfo } from '../../components/shared/toastr/ToastrActions';
import { copyTextToClipboard } from '../../utils/clipboard';
import { objectById } from '../../shared/utils';
import { indexById } from '../../stores/app/utils';
import PageLayout from '../shared/layout/PageLayout';
import './FundPage.scss';
import { Button, Checkbox, DrawerBody, DrawerHeader, DrawerHeaderTitle, InlineDrawer, Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { Dismiss24Regular, ArrowDownloadRegular, MoreHorizontal20Regular } from "@fluentui/react-icons"
import { FundFilters } from 'components/fund/filters/FundFilters';
import { FundPageRibbon } from 'components/fund/FundPageRibbon';
import { FundPager } from 'components/fund/FundPager';
import { MultiFundActionDialog } from 'components/fund/MultiFundActionDialog';
import { defineMessages, FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl';

const OUTPUT_MAX_NUMBER = 10;

const messages = defineMessages({
    // Id převzatá z legacy katalogu beze změny. Placeholder {0} zůstává:
    // ICU bere jako jméno argumentu i číslo.
    addTitle: { id: 'arr.fund.title.add', defaultMessage: 'Vytvoření nového AS' },
    importTitle: { id: 'import.title.fund', defaultMessage: 'Import archivního souboru' },
    exportTitle: { id: 'export.title.fund', defaultMessage: 'Export archivního souboru' },
    approveTitle: { id: 'arr.fund.title.approve', defaultMessage: 'Uzavření verze AS' },
    ruleSetTitle: { id: 'arr.fund.title.ruleSet', defaultMessage: 'Změnit pravidla' },
    updateTitle: { id: 'arr.fund.title.update', defaultMessage: 'Úprava AS' },
    searchTitle: { id: 'arr.fund.title.search', defaultMessage: 'Vyhledat v archivních souborech' },
    listCreated: { id: 'arr.fund.list.created', defaultMessage: 'vytvořeno: {date}, {time}' },
    deleteConfirm: {
        id: 'arr.fund.action.delete.confirm',
        defaultMessage: 'Opravdu chcete vymazat celý AS {0}?',
    },
    deleteHistoryConfirm: {
        id: 'arr.fund.action.deletehistory.confirm',
        defaultMessage: 'Opravdu chcete vymazat historii změn AS {0}?',
    },
    issueSettingsTitle: { id: 'arr.issues.settings.title', defaultMessage: 'Nastavení lektorování' },
    ribbonUpdate: { id: 'ribbon.action.arr.fund.update', defaultMessage: 'Upravit vlastnosti' },
    ribbonRuleSet: { id: 'ribbon.action.arr.fund.ruleSet', defaultMessage: 'Změnit pravidla' },
    ribbonApprove: { id: 'ribbon.action.arr.fund.approve', defaultMessage: 'Nová verze AS' },
    ribbonExport: { id: 'ribbon.action.arr.fund.export', defaultMessage: 'Export' },
    deleteHistory: { id: 'arr.fund.action.deletehistory', defaultMessage: 'Vymazání historie změn' },
    delete: { id: 'arr.fund.action.delete', defaultMessage: 'Smazat AS' },
    fundPageExportResults: {
        id: "fundPage_export_results",
        defaultMessage: "Stáhnout CSV",
    },
    fundPageMultiActionTitle: {
        id: "fundPage.multiAction.title",
        defaultMessage: "Hromadné akce nad AS",
    },
    fundPageMultiActionStart: {
        id: "fundPage.multiAction.start",
        defaultMessage: "Hromadné akce nad AS",
    },
    fundPageMultiActionSelected: {
        id: "fundPage.multiAction.selected",
        defaultMessage: "Vybráno: {count}",
    },
    fundPageMultiActionSelectAll: {
        id: "fundPage.multiAction.selectAll",
        defaultMessage: "Vybrat vše odpovídající filtru ({count})",
    },
    fundPageMultiActionRun: {
        id: "fundPage.multiAction.run",
        defaultMessage: "Vybrat akci",
    },
    fundPageMultiActionCancel: {
        id: "fundPage.multiAction.cancel",
        defaultMessage: "Zrušit",
    },
    fundPageDrawerClose: {
        id: "fundPage.drawer.close",
        defaultMessage: "Zavřít",
    },
    fundPageDrawerRules: {
        id: "fundPage.drawer.rules",
        defaultMessage: "Pravidla",
    },
    fundPageDrawerOutputs: {
        id: "fundPage.drawer.outputs",
        defaultMessage: "Výstupy",
    },
    fundPageDrawerAllOutputs: {
        id: "fundPage.drawer.allOutputs",
        defaultMessage: "Všechny výstupy...",
    },
    fundPageDrawerVersions: {
        id: "fundPage.drawer.versions",
        defaultMessage: "Verze",
    },
    fundPageDrawerCurrentVersion: {
        id: "fundPage.drawer.currentVersion",
        defaultMessage: "Aktuální verze",
    },
    fundPageDrawerEntityScopes: {
        id: "fundPage.drawer.entityScopes",
        defaultMessage: "Oblasti entit",
    },
})


/**
 * Stránka archivní soubory.
 */

class FundPage extends AbstractReactComponent {
    static propTypes = {
        maxSize: PropTypes.number,
    };

    static defaultProps = {
        maxSize: DEFAULT_FUND_LIST_MAX_SIZE,
    };

    state = {
        institutions: [],
        sidebarOpen: false,
        selectionMode: false,
        selectedFundIds: [],
        selectAllMatching: false,
    };

    constructor(props) {
        super(props);

        this.bindMethods(
            'handleAddFund',
            'handleImport',
            'handleExportDialog',
            'renderListItem',
            'handleSelect',
            'handleSearchClear',
            'handleApproveFundVersion',
            'handleEditFundVersion',
            'handleCallEditFundVersion',
            'handleDeleteFund',
            'handleDeleteFundHistory',
            'handleRuleSetUpdateFundVersion',
        );

        this.buildRibbon = this.buildRibbon.bind(this);
        WebApi.getInstitutions(true).then(institutions => this.setState({ institutions }));
    }

    UNSAFE_componentWillReceiveProps() {
        this.props.dispatch(fundsFetchIfNeeded());
        this.props.dispatch(fundsFundDetailFetchIfNeeded());
        this.props.dispatch(refInstitutionsFetchIfNeeded());
        this.props.dispatch(refRuleSetFetchIfNeeded());
    }

    getActiveFundIndex() {
        const { fundRegion } = this.props;
        if (fundRegion.fundDetail.id === null) {
            return undefined;
        }
        const index = indexById(fundRegion.funds, fundRegion.fundDetail.id);
        return index === null ? undefined : index;
    }

    scrollActiveFundIntoView() {
        const activeIndex = this.getActiveFundIndex();
        if (activeIndex === undefined) {
            return;
        }
        this.refs.fundList?.ensureItemVisible(activeIndex, { center: true, onlyIfNeeded: true });
    }

    componentDidUpdate(prevProps, prevState) {
        const activeFundChanged = prevProps.fundRegion.fundDetail.id !== this.props.fundRegion.fundDetail.id;
        const fundsChanged = prevProps.fundRegion.funds !== this.props.fundRegion.funds;
        // the institution bubble is rendered only once both institution sources
        // are loaded, which changes row heights and invalidates a previous scroll
        const institutionsChanged = prevState.institutions !== this.state.institutions;
        const institutionsAllChanged = prevProps.institutionsAll.items !== this.props.institutionsAll.items;

        if (activeFundChanged || fundsChanged || institutionsChanged || institutionsAllChanged) {
            this.scrollActiveFundIntoView();
        }
    }

    componentDidMount() {
        const { dispatch, fundRegion, history, select = false } = this.props;
        dispatch(fundsFetchIfNeeded());
        dispatch(refInstitutionsFetchIfNeeded());

        if (!select) {
            const matchId = this.props.match.params.id;

            // pokud si pamatujeme poslední navštívý AS při prvním vstupu - provedeme přesměrování
            if (fundRegion.fundDetail.id !== null && matchId == null) {
                history.replace(urlFund(fundRegion.fundDetail.id));
            }

            if (matchId) {
                dispatch(fundsSelectFund(Number(matchId)));

                this.handleToggleDrawer(true)
            }
        }

        this.scrollActiveFundIntoView();
    }

    handleAddFund() {
        const { userDetail } = this.props;
        let initData = {};
        if (!userDetail.hasOne(perms.ADMIN, perms.FUND_ADMIN)) {
            initData.fundAdmins = [{ id: 'default', user: userDetail }];
        }
        WebApi.getAllScopes().then(scopes => {
            this.props.dispatch(
                modalDialogShow(
                    this,
                    this.props.intl.formatMessage(messages.addTitle),
                    <FundForm
                        create
                        initialValues={initData}
                        scopeList={scopes}
                        onSubmitForm={data => {
                            return this.props.dispatch(createFund(data));
                        }}
                    />,
                ),
            );
        });
    }

    handleImport() {
        this.props.dispatch(modalDialogShow(this, this.props.intl.formatMessage(messages.importTitle), <ImportForm fund={true} />));
    }

    async handleExportDialog(fundId) {
        const { dispatch } = this.props;
        const fundDetail = await getFundDetail(fundId);

        dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(messages.exportTitle),
                <ExportForm
                    fund={true}
                    initialValues={{
                        includeUUID: true,
                        includeAccessPoints: true,
                        includeDaos: true
                    }}
                    onSubmitForm={({ exportFilter, includeUUID, includeAccessPoints, includeDaos }) => {
                        return dispatch(exportFund(fundDetail.versionId, { exportFilter, includeUUID, includeAccessPoints, includeDaos }));
                    }}
                />,
            ),
        );
    }

    /**
     * Zobrazení dualogu uzavření verze AS.
     */
    async handleApproveFundVersion(fundId) {
        const { dispatch } = this.props;

        const fundDetail = await getFundDetail(fundId);
        const data = { dateRange: fundDetail.activeVersion.dateRange, };

        dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(messages.approveTitle),
                <FundForm
                    approve
                    initialValues={data}
                    onSubmitForm={() => {
                        return dispatch(approveFund(fundDetail.versionId));
                    }}
                />,
            ),
        );
    }

    /**
     * Zobrazení dualogu uzavření verze AS.
     */
    async handleRuleSetUpdateFundVersion(fundId) {
        const { institutionsAll } = this.props;
        const fundDetail = await getFundDetail(fundId);
        const institution = objectById(institutionsAll.items, fundDetail.institutionId);

        const initData = {
            ruleSetId: fundDetail.activeVersion.ruleSetId,
        };
        this.props.dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(messages.ruleSetTitle),
                <FundForm
                    ruleSet
                    initialValues={initData}
                    onSubmitForm={data =>
                        this.handleCallEditFundVersion(fundDetail, {
                            ...data,
                            name: fundDetail.name,
                            institutionIdentifier: institution.code,
                            internalCode: fundDetail.internalCode,
                            fundNumber: fundDetail.fundNumber,
                            unitdate: fundDetail.unitdate,
                            mark: fundDetail.mark,
                        })
                    }
                />,
            ),
        );
    }

    async handleEditFundVersion(fundId) {
        const { ruleSet, institutionsAll } = this.props;
        const fundDetail = await getFundDetail(fundId);
        const rules = objectById(ruleSet.items, fundDetail.activeVersion.ruleSetId);
        const institution = objectById(institutionsAll.items, fundDetail.institutionId);
        const scopeList = await WebApi.getAllScopes();

        const data = {
            name: fundDetail.name,
            institutionIdentifier: institution.code,
            internalCode: fundDetail.internalCode,
            fundNumber: fundDetail.fundNumber,
            unitdate: fundDetail.unitdate,
            mark: fundDetail.mark,
            ruleSetCode: rules.code,
            scopes: (fundDetail.apScopes || []).map(i => i.code),
            managed: fundDetail.managed,
        };

        this.props.dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(messages.updateTitle),
                <FundForm
                    update
                    initialValues={data}
                    scopeList={scopeList}
                    onSubmitForm={(_data) => this.handleCallEditFundVersion(fundDetail, _data)}
                />,
            ),
        );
    }

    async handleCallEditFundVersion(fundDetail, data) {
        const { dispatch } = this.props;

        dispatch(scopesDirty(fundDetail.versionId));
        return dispatch(
            updateFund(fundDetail.id, {
                scopes: data.scopes,
                institutionIdentifier: data.institutionIdentifier,
                internalCode: data.internalCode,
                name: data.name,
                ruleSetCode: data.ruleSetCode,
                fundNumber: data.fundNumber,
                unitdate: data.unitdate,
                mark: data.mark,
                managed: data.managed,
            }),
        );
    }

    /**
     * Vyvolání dialogu s vyhledáním na všemi AS.
     */
    handleFundsSearchForm = () => {
        this.props.dispatch(modalDialogShow(this, this.props.intl.formatMessage(messages.searchTitle), <SearchFundsForm />));
    };

    buildRibbon() {
        return <FundPageRibbon
            onAddFund={this.handleAddFund}
            onFundsSearchForm={this.handleFundsSearchForm}
            onImport={this.handleImport}
        />
    }

    async handleDeleteFund(fundId) {
        const { dispatch } = this.props;
        const fundDetail = await getFundDetail(fundId);

        const response = await dispatch(showConfirmDialog(this.props.intl.formatMessage(messages.deleteConfirm, { 0: fundDetail.name })));
        if (response) {
            dispatch(deleteFund(fundDetail.id));
        }
    }

    async handleDeleteFundHistory(fundId) {
        const { dispatch } = this.props;
        const fundDetail = await getFundDetail(fundId);

        const response = await dispatch(showConfirmDialog(this.props.intl.formatMessage(messages.deleteHistoryConfirm, { 0: fundDetail.name })));
        if (response) {
            dispatch(deleteFundHistory(fundDetail.id));
        }
    }

    copyToClipboard = async (string) => {
        const { dispatch, intl } = this.props;
        const copied = await copyTextToClipboard(string);
        dispatch(
            copied
                ? addToastrInfo(intl.formatMessage(globalMessages.copyToClipboardFinished))
                : addToastrDanger(intl.formatMessage(globalMessages.copyToClipboardUnavailable)),
        );
    };

    handleIssuesSettings = async (fundId) => {
        const { dispatch } = this.props;
        const fundDetail = await getFundDetail(fundId);

        dispatch(
            modalDialogShow(this, this.props.intl.formatMessage(messages.issueSettingsTitle), <IssueLists fundId={fundDetail.id} />),
        );
    };

    async handleShowInArr(item) {
        const { dispatch } = this.props;

        // Load fund detail
        const { id, versions } = await getFundDetail(item.id);

        dispatch(globalFundTreeInvalidate());
        // redirecting to arrangement page of the loaded fund
        dispatch(routerNavigate(urlFundTree(id, versions[0].id)));
    }

    /**
     * Akce dostupné pro daný AS podle oprávnění uživatele. Sdílené položkou seznamu a detailem AS.
     */
    buildFundActions(item) {
        const { userDetail } = this.props;

        const itemActions = [];
        if (item.id !== null) {
            if (userDetail.hasOne(perms.FUND_ADMIN, { type: perms.FUND_VER_WR, fundId: item.id })) {
                itemActions.push(
                    <MenuItem
                        key="edit-version"
                        icon={<Icon glyph="fa-pencil" />}
                        title={this.props.intl.formatMessage(messages.ribbonUpdate)}
                        onClick={() => this.handleEditFundVersion(item.id)}
                    >
                        {<FormattedMessage {...messages.ribbonUpdate} />}
                    </MenuItem>,
                    <MenuItem
                        key="rule-set-version"
                        icon={<Icon glyph="fa-calendar-check-o" />}
                        title={this.props.intl.formatMessage(messages.ribbonRuleSet)}
                        onClick={() => this.handleRuleSetUpdateFundVersion(item.id)}
                    >
                        {<FormattedMessage {...messages.ribbonRuleSet} />}
                    </MenuItem>,
                    <MenuItem
                        key="approve-version"
                        icon={<Icon glyph="fa-code-fork" />}
                        title={this.props.intl.formatMessage(messages.ribbonApprove)}
                        onClick={() => this.handleApproveFundVersion(item.id)}
                    >
                        {<FormattedMessage {...messages.ribbonApprove} />}
                    </MenuItem>,
                );
            }
            if (userDetail.hasOne(perms.FUND_ISSUE_ADMIN_ALL, { type: perms.FUND_ISSUE_ADMIN, fundId: item.id })) {
                itemActions.push(
                    <MenuItem
                        key="fa-lecturing"
                        icon={<Icon glyph="fa-commenting" />}
                        title={this.props.intl.formatMessage(messages.issueSettingsTitle)}
                        onClick={() => this.handleIssuesSettings(item.id)}
                    >
                        {<FormattedMessage {...messages.issueSettingsTitle} />}
                    </MenuItem>,
                );
            }
            if (userDetail.hasOne(perms.FUND_EXPORT_ALL, { type: perms.FUND_EXPORT, fundId: item.id })) {
                itemActions.push(
                    <MenuItem
                        key="fa-export"
                        icon={<Icon glyph="fa-download" />}
                        title={this.props.intl.formatMessage(messages.ribbonExport)}
                        onClick={() => this.handleExportDialog(item.id)}
                    >
                        {<FormattedMessage {...messages.ribbonExport} />}
                    </MenuItem>,
                );
            }
            if (userDetail.hasOne(perms.FUND_ADMIN)) {
                itemActions.push(
                    <MenuItem
                        className="danger"
                        key="fa-deletehistory"
                        icon={<Icon glyph="fa-times-circle-o" />}
                        title={this.props.intl.formatMessage(messages.deleteHistory)}
                        onClick={() => this.handleDeleteFundHistory(item.id)}
                    >
                        {<FormattedMessage {...messages.deleteHistory} />}
                    </MenuItem>,
                );
                itemActions.push(
                    <MenuItem
                        className="danger"
                        key="fa-delete"
                        icon={<Icon glyph="fa-trash" />}
                        title={this.props.intl.formatMessage(messages.delete)}
                        onClick={() => this.handleDeleteFund(item.id)}
                    >
                        {<FormattedMessage {...messages.delete} />}
                    </MenuItem>,
                );
            }
        }
        return itemActions;
    }

    renderListItem(props) {
        const { institutionsAll } = this.props;
        const { institutions, selectionMode, selectedFundIds, selectAllMatching } = this.state;
        const { item } = props;
        // hide institution name, when only one is used for funds
        const institution = institutions?.length > 1 ? institutionsAll.items.find(({ code }) => code == item.institutionIdentifier) : undefined;

        const itemActions = this.buildFundActions(item);

        return <>
            {selectionMode && item.id !== null &&
                <div
                    style={{ display: "flex", alignItems: "center", paddingRight: "8px", flexShrink: 0 }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Checkbox
                        checked={selectAllMatching || selectedFundIds.includes(item.id)}
                        disabled={selectAllMatching}
                        onChange={(_e, d) => this.handleToggleFundCheck(item.id, !!d.checked)}
                    />
                </div>
            }
            <div style={{ flexGrow: 1, flexShrink: 1, overflow: "hidden" }}>
                <div className="item-row" key={item.id}>
                    {selectionMode
                        ? <span className="name main" title={item.name} key={`fund-${item.id}`}>{item.name}</span>
                        : <Link className="name main link" title={item.name} key={`fund-${item.id}`} to={urlFundTree(item.id)} onMouseDown={(e) => e.stopPropagation()}>
                            {item.name}
                        </Link>
                    }
                    <div style={{ flexGrow: 1 }}></div>
                </div>
                <div className="item-row desc" key={item.id + '-x'}>
                    <div style={{ display: "flex", width: "100%" }}>
                        {/* <span className="desc-part id bubble" onClick={() => this.copyToClipboard(item.id)}>{item.id}</span> */}
                        {item.fundNumber != undefined && <span className="desc-part bubble internal-code" onClick={() => this.copyToClipboard(item.fundNumber)}>{item.fundNumber}</span>}
                        {item.internalCode && <span className="desc-part bubble" onClick={() => this.copyToClipboard(item.internalCode)}>{item.internalCode}</span>}
                        {item.mark && <span className="desc-part bubble" onClick={() => this.copyToClipboard(item.mark)}>{item.mark}</span>}
                        {institution && <Link className="name desc-part link bubble shrink" title={institution.name} key={`fund-${item.id}`} to={urlEntity(institution.accessPointId)} onMouseDown={(e) => e.stopPropagation()}>
                            <div>
                                {institution.name}
                            </div>
                        </Link>}
                        {item.unitdate && <span className="desc-part bubble id" onClick={() => this.copyToClipboard(item.unitdate)}>{item.unitdate}</span>}
                    </div>
                    <div style={{ flexGrow: 1 }}></div>
                </div>
            </div>
            <div style={{
                // flexGrow: 1,
                // flexShrink: 1,
                overflow: "hidden",
            }}>
                {/* <div style={{ display: "flex", justifyContent: "flex-end", columnGap: "10px" }}> */}
                {/*     <Link ><Icon glyph="fa-code-fork" /> 3</Link> */}
                {/*     <Link to={urlFundOutputs(item.id, item.versionId)}><Icon glyph="fa-print" /> 0</Link> */}
                {/* </div> */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {item.createDate && <span className="desc-part muted">
                        <FormattedMessage
                            {...messages.listCreated}
                            values={{
                                date: <FormattedDate value={item.createDate} />,
                                time: <FormattedTime value={item.createDate} />,
                            }}
                        />
                    </span>}
                </div>
            </div>
            <div className="fund-actions" onMouseDown={(e) => { e.stopPropagation() }}>
                {itemActions.length > 0 &&
                    <Menu>
                        <MenuTrigger disableButtonEnhancement={true}>
                            <MenuButton appearance='subtle' icon={<MoreHorizontal20Regular />} />
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                {itemActions.map((action) => {
                                    return action;
                                })}
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                }
            </div>
        </>;
    }

    handleSelect(item) {
        const { history, dispatch } = this.props;
        const { selectionMode, selectAllMatching, selectedFundIds } = this.state;

        if (selectionMode) {
            if (item.id != null && !selectAllMatching) {
                this.handleToggleFundCheck(item.id, !selectedFundIds.includes(item.id));
            }
            return;
        }

        this.handleToggleDrawer(true)

        history.push(urlFund(item.id));
        dispatch(fundsSelectFund(item.id));
    }

    handleEnterSelectionMode = () => {
        this.setState({ selectionMode: true, selectedFundIds: [], selectAllMatching: false });
    };

    handleCancelSelection = () => {
        this.setState({ selectionMode: false, selectedFundIds: [], selectAllMatching: false });
    };

    handleToggleFundCheck = (fundId, checked) => {
        this.setState(({ selectedFundIds }) => {
            const set = new Set(selectedFundIds);
            if (checked) {
                set.add(fundId);
            } else {
                set.delete(fundId);
            }
            return { selectedFundIds: [...set] };
        });
    };

    handleToggleSelectAllMatching = (checked) => {
        this.setState({ selectAllMatching: checked });
    };

    handleRunMultiFund = () => {
        const { dispatch, fundRegion, intl } = this.props;
        const { selectAllMatching, selectedFundIds } = this.state;

        // Při výběru "vše odpovídající filtru" se předává aktivní filtr — fondy se
        // vyhodnocují až na serveru, jejich id se na klienta nikdy nestahují.
        let dialogProps;
        if (selectAllMatching) {
            dialogProps = { filters: fundRegion.filter.filter?.map((f) => f.getFilterValue(f)) ?? [] };
        } else {
            if (selectedFundIds.length === 0) {
                return;
            }
            dialogProps = { fundIds: selectedFundIds };
        }

        dispatch(
            modalDialogShow(
                this,
                intl.formatMessage(messages.fundPageMultiActionTitle),
                <MultiFundActionDialog {...dialogProps} />,
            ),
        );
    };

    // handleSearch({fulltext}) {
    //     const {filter} = this.props.fundRegion;
    //     this.props.dispatch(fundsFilter({
    //         ...filter,
    //         fulltext,
    //     }));
    // }

    handleSearchClear() {
        this.props.dispatch(fundsSearch(''));
    }

    handleFilterPrev = () => {
        const { filter } = this.props.fundRegion;
        let { from } = filter;

        if (from >= DEFAULT_FUND_LIST_MAX_SIZE) {
            from = from - DEFAULT_FUND_LIST_MAX_SIZE;
            this.props.dispatch(fundsFilter({ ...filter, from }));
        }
    };

    handleFilterNext = () => {
        const { filter, fundsCount } = this.props.fundRegion;
        let { from } = filter;

        if (from < fundsCount - DEFAULT_FUND_LIST_MAX_SIZE) {
            from = from + DEFAULT_FUND_LIST_MAX_SIZE;
            this.props.dispatch(fundsFilter({ ...filter, from }));
        }
    };

    handleFilterInstitution = institutionIdentifier => {
        const { filter } = this.props.fundRegion;

        if (institutionIdentifier !== filter.institutionIdentifier) {
            this.props.dispatch(fundsFilter({ ...filter, institutionIdentifier }));
        }
    };

    handleToggleDrawer = (state) => {
        const { sidebarOpen } = this.state;
        this.setState({ sidebarOpen: state !== undefined ? state : !sidebarOpen });
    }

    handleFiltersChange = (filters) => {
        const { dispatch, fundRegion } = this.props;
        dispatch(fundsFilter({ ...fundRegion.filter, filter: filters, from: 0 }));
    }

    handleExportResults = () => {
        const { dispatch } = this.props;
        dispatch(fundsExportResults());
    }

    render() {
        const { fundRegion, maxSize, ruleSet, userDetail, intl } = this.props;
        const { sidebarOpen, selectionMode, selectedFundIds, selectAllMatching } = this.state;

        const activeIndex = this.getActiveFundIndex();

        const activeVersion = fundRegion.fundDetail.versions?.find(({ id }) => fundRegion.fundDetail.activeVersion.id === id);
        const activeRuleSet = activeVersion?.ruleSetId != undefined ? ruleSet.itemsMap[activeVersion.ruleSetId] : undefined;

        const detailActions = fundRegion.fundDetail.id != null ? this.buildFundActions(fundRegion.fundDetail) : [];

        const leftPanel = (
            <div className="fund-list-container">
                <div className="filter-container" style={{ display: "flex" }}>
                    <FundPager
                        onPrevious={this.handleFilterPrev}
                        onNext={this.handleFilterNext}
                        from={fundRegion.filter.from}
                        pageSize={maxSize}
                        totalCount={fundRegion.fundsCount}
                    />
                    <FundFilters currentFilters={fundRegion.filter.filter} onChange={this.handleFiltersChange} />
                    <div style={{ margin: "5px", flexShrink: 0 }} onClick={this.handleExportResults}>
                        <Button icon={<ArrowDownloadRegular />}>
                            <FormattedMessage {...messages.fundPageExportResults} />
                        </Button>
                    </div>
                    {userDetail.hasOne(perms.FUND_BA_ALL) && !selectionMode &&
                        <div style={{ margin: "5px", flexShrink: 0 }}>
                            <Button onClick={this.handleEnterSelectionMode}>
                                <FormattedMessage {...messages.fundPageMultiActionStart} />
                            </Button>
                        </div>
                    }
                </div>
                {selectionMode &&
                    <div className="filter-container" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ flexShrink: 0 }}>
                            <FormattedMessage
                                {...messages.fundPageMultiActionSelected}
                                values={{ count: selectAllMatching ? fundRegion.fundsCount : selectedFundIds.length }}
                            />
                        </span>
                        <Checkbox
                            label={intl.formatMessage(messages.fundPageMultiActionSelectAll, {
                                count: fundRegion.fundsCount,
                            })}
                            checked={selectAllMatching}
                            onChange={(_e, d) => this.handleToggleSelectAllMatching(!!d.checked)}
                        />
                        <div style={{ flexGrow: 1 }} />
                        <Button
                            appearance="primary"
                            disabled={!selectAllMatching && selectedFundIds.length === 0}
                            onClick={this.handleRunMultiFund}
                        >
                            <FormattedMessage {...messages.fundPageMultiActionRun} />
                        </Button>
                        <Button onClick={this.handleCancelSelection}>
                            <FormattedMessage {...messages.fundPageMultiActionCancel} />
                        </Button>
                    </div>
                }
                <div style={{ position: "relative", display: "flex", flexGrow: 1, flexShrink: 1, height: "400px" }}>
                    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, overflow: "hidden" }}>
                        <ListBox
                            className="fund-listbox"
                            ref="fundList"
                            items={fundRegion.funds}
                            activeIndex={activeIndex}
                            renderItemContent={this.renderListItem}
                            // onFocus={this.handleSelect}
                            onSelect={this.handleSelect}
                        />
                    </div>
                    <InlineDrawer className="drawer" position='end' separator={true} open={sidebarOpen} size='small' style={{ height: "auto", flexShrink: 0 }}>
                        <DrawerHeader>
                            <DrawerHeaderTitle
                                action={
                                    <>
                                        {detailActions.length > 0 &&
                                            <Menu>
                                                <MenuTrigger disableButtonEnhancement={true}>
                                                    <MenuButton appearance='subtle' icon={<MoreHorizontal20Regular />} />
                                                </MenuTrigger>
                                                <MenuPopover>
                                                    <MenuList>
                                                        {detailActions}
                                                    </MenuList>
                                                </MenuPopover>
                                            </Menu>
                                        }
                                        <Button
                                            appearance="subtle"
                                            aria-label={intl.formatMessage(messages.fundPageDrawerClose)}
                                            icon={<Dismiss24Regular />}
                                            onClick={() => this.handleToggleDrawer(false)}
                                        />
                                    </>
                                }
                            >
                                <Link
                                    className="name main link"
                                    title={fundRegion.fundDetail.name}
                                    key={`fund-${fundRegion.fundDetail.id}`}
                                    to={urlFundTree(fundRegion.fundDetail.id)}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    {fundRegion.fundDetail.name}
                                </Link>
                            </DrawerHeaderTitle>
                        </DrawerHeader>
                        <DrawerBody style={{ overflow: "auto" }}>
                            <div style={{ marginBottom: "10px" }}>
                                {activeRuleSet && <>
                                    <div><b><FormattedMessage {...messages.fundPageDrawerRules} /></b></div>
                                    {activeRuleSet?.name}
                                </>}
                                <div><b><FormattedMessage {...messages.fundPageDrawerOutputs} /></b></div>
                                {/* <div style={{overflow: "auto"}}> */}
                                {fundRegion.fundDetail.validNamedOutputs?.slice(0, OUTPUT_MAX_NUMBER).sort((a, b) => new Date(b.generatedDate) - new Date(a.generatedDate)).map(({ name, id, generatedDate }) => {
                                    return <div key={id} style={{ marginBottom: "5px" }}>
                                        <div>
                                            <Link to={urlFundOutputs(fundRegion.fundDetail.id, undefined, id)}>
                                                {name}
                                            </Link>
                                        </div>
                                        {generatedDate && <div>
                                            {new Date(generatedDate).toLocaleDateString()}, {new Date(generatedDate).toLocaleTimeString()}
                                        </div>}
                                    </div>
                                })}
                                <div>
                                    <Link to={urlFundOutputs(fundRegion.fundDetail.id)}>
                                        <FormattedMessage {...messages.fundPageDrawerAllOutputs} />
                                    </Link>
                                </div>
                                {/* </div> */}
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div><b><FormattedMessage {...messages.fundPageDrawerVersions} /></b></div>
                                {fundRegion.fundDetail.versions?.map(({ lockDate, id }) => {
                                    return <div key={id} style={{ fontWeight: fundRegion.fundDetail.versionId === id ? "bold" : undefined }}>
                                        <Link to={urlFundTree(fundRegion.fundDetail.id, lockDate ? id : undefined)}>
                                            {lockDate ? <>
                                                {new Date(lockDate).toLocaleDateString()}
                                                {", "}
                                                {new Date(lockDate).toLocaleTimeString()}
                                            </> : <>
                                                <FormattedMessage {...messages.fundPageDrawerCurrentVersion} />
                                            </>}
                                        </Link>
                                    </div>
                                })}
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div><b><FormattedMessage {...messages.fundPageDrawerEntityScopes} /></b></div>
                                {fundRegion.fundDetail.apScopes?.map(({ name }) => {
                                    return <div key={name}>
                                        {name}
                                    </div>
                                })}
                            </div>
                        </DrawerBody>
                    </InlineDrawer>
                </div>
            </div>
        );

        // const centerPanel = (
        //     <FundDetail fundDetail={fundRegion.fundDetail} focus={focus} fundCount={fundRegion.funds.length} />
        // );

        // let rightPanel;
        // if (fundRegion.fundDetail.fetched) {
        //     rightPanel = <FundDetailExt fundDetail={fundRegion.fundDetail} focus={focus} />;
        // }

        return (
            <>
                <FundListImportListener />
                <PageLayout
                    className="fund-page"
                    ribbon={this.buildRibbon()}
                    // leftPanel={leftPanel}
                    centerPanel={leftPanel}
                    // rightPanel={rightPanel}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    const { focus, fundRegion, userDetail, refTables } = state;

    return {
        focus,
        fundRegion,
        userDetail,
        ruleSet: refTables.ruleSet,
        institutionsAll: refTables.institutions,
    };
}

export default withRouter(connect(mapStateToProps)(injectIntl(FundPage)));
